import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {ClassifiedsMccService} from '../../services/classifieds-mcc.service';
import {UrlService} from '../../services/url.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';
import {Subject} from 'rxjs/Subject';

@Component({
    templateUrl: 'classifieds-mcc.component.html',
})
export class ClassifiedsMccComponent implements OnInit, OnDestroy {
    private $destroy = new Subject();

    constructor(public classifiedsMccService: ClassifiedsMccService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.classifiedsMccService.getBuildingsRequest()
            .pipe(
                takeUntil(this.$destroy)
            )
            .subscribe();

        this.urlService.onUrlChange
            .pipe(
                tap(() => this.classifiedsMccService.tabId = this.urlService.queryParams['tab']),
                flatMap(
                    () => this.classifiedsMccService.getDataByQueryParams().pipe(
                        takeUntil(this.urlService.instantOnUrlChange)
                    )
                )
            )
            .subscribe();

        this.urlService.setQueryParams('allClassifiedsMcc');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.classifiedsMccService.resetData();
        this.urlService.resetQueryParams();
        this.$destroy.next();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.classifiedsMccService.emptyRowService.fillEmptyRow();
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/classifieds-mcc/classifieds-mcc.component.ts